module.exports = __webpack_public_path__ + "img/janet.a6f62cd3.png";